// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1zDK4","header":"ClearentDisclaimer_header__Zq0FZ","inner":"ClearentDisclaimer_inner__zDpRQ"};